import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import TeamIcon from './_team-icon.js'

export default {
  name: 'Participants',
  values: {
    showSeparator: false,
    showStartingPitcher: true,
    showTeamLogo: false,
    showShortName: false,
    textWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    drawLabelTextWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexBasis: '33%',
          alignItems: 'center',
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          justifyContent: 'space-around',
        },
      },
    },
    text: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 1,
        container: {
          flexGrow: 0,
        },
      },
    },
    startingPitcherName: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    separatorWrapper: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          maxHeight: '0px',
          flexBasis: '4px',
          bottom: '8px',
        },
      },
    },
    separatorWrapperWithTeamLogo: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          maxHeight: '0px',
          flexBasis: '4px',
          bottom: '8px',
          left: '28px',
        },
      },
    },
    separatorText: {
      configSet: Text,
      configValues: {},
    },
    outrightText: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexBasis: '100%',
          alignItems: 'center',
        },
        style: {
          textAlign: 'left',
        },
      },
    },
    teamIcon: {
      configSet: TeamIcon,
      configValues: {
        container: {
          flexGrow: 0,
          display: 'flex',
          alignItems: 'center',
        },
        image: {
          style: {
            width: '24px',
            height: '24px',
          },
        },
      },
    },
    teamIconHidden: {
      configSet: TeamIcon,
      configValues: {
        container: {
          display: 'none',
        },
      },
    },
    participantWrapper: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          flexBasis: '33%',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
